import * as R from 'remeda';
import { ActionType } from 'typesafe-actions';

import * as forecastActions from './actions';
import * as forecastConstants from './constants';
import forecastReducer from './reducer';
import * as forecastSagas from './sagas';
import * as forecastSelectors from './selectors';

export type ForecastState = { selectedWeek: Time.Week };

export type ForecastAction = ActionType<typeof forecastActions>;

const _forecastSagaActions = R.pick(forecastActions, [
  'startCreateForecast',
  'startForecastWeek',
]);

export type ForecastSagaAction = ActionType<typeof _forecastSagaActions>;

export {
  forecastActions,
  forecastConstants,
  forecastReducer,
  forecastSagas,
  forecastSelectors,
};
